import type { Maybe, SortField } from '@pylot-data/pylotschema'

const sortLabelsMap: { [k: string]: string } = {
    position: 'Recomendado',
    bestsellers: 'Más vendidos',
    new: 'Nuevo',
    saving: 'Mejor descuento',
    price_asc: 'Menor precio',
    price_desc: 'Mayor precio',
    rating_summary: 'Mejor Evaluados'
}

const sortLabelsOrder = [
    'new',
    'price_asc',
    'price_desc',
    'rating_summary',
    'bestsellers',
    'saving',
    'position'
]

/** Etiqueta visible para un valor de orden del API (`price_asc` → `Menor precio`). */
export const getSortingLabel = (value?: string | null): string | undefined =>
    value ? sortLabelsMap[value] : undefined

export const translateSortingLabels = (
    options: Maybe<Maybe<SortField>[]> | undefined = []
): SortField[] => {
    return (options ?? [])
        .filter(Boolean) // quita null/undefined del array
        .map((option) => ({
            ...option!,
            label: sortLabelsMap[String(option?.value)] || option?.label
        }))
}

export const sortSortingLabels = (
    options: Maybe<Maybe<SortField>[]> | undefined = []
): SortField[] => {
    return [...(options ?? []).filter(Boolean)].sort(
        (a, b) =>
            sortLabelsOrder.indexOf(a?.value || '') -
            sortLabelsOrder.indexOf(b?.value || '')
    ) as SortField[]
}
